var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-autocomplete", {
    directives: [{ name: "input-limit", rawName: "v-input-limit" }],
    staticClass: "inline-input",
    attrs: {
      maxlength: 64,
      "fetch-suggestions": _vm.querySearch,
      placeholder: _vm._placeholder,
      tips: _vm.$t("v_email_64"),
      disabled: _vm.disabled,
      "data-input-type": "nospace",
      "trigger-on-focus": false,
      debounce: 0,
      width: _vm.width,
    },
    on: { input: _vm.handleInput },
    model: {
      value: _vm.subString,
      callback: function ($$v) {
        _vm.subString = $$v
      },
      expression: "subString",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }